export default "__VITE_ASSET__CxXX4m39__"